import { BadgeCounter, ButtonFilterText } from '@/components/custom';
import { IHasClassName } from '@/interfaces';
import { useQueryParams } from '@/hooks';
import { ReactNode } from 'react';

type TProps = IHasClassName & {
  value?: string | number;
  enableToggle?: boolean;
  isLoading?: boolean;
  paramName?: string;
  text: ReactNode;
  count?: number;
}

const ButtonFilterCountable = ({ value, text, enableToggle, className, paramName = 'gender', count = 0, isLoading = false }: TProps) => {

  const { values: [currentGender], setValue, deleteValue } = useQueryParams([paramName]);

  const isActive = value === currentGender;

  const handleOnClick = () => {

    if (!enableToggle) {
      !isActive &&
        setValue(paramName, value);
    } else {
      isActive
        ? deleteValue(paramName)
        : setValue(paramName, value);
    }

  };

  return (
    <ButtonFilterText
      title={
        !isActive
          ? 'Activer le filtre'
          : enableToggle
            ? 'Désactiver le filtre'
            : 'Filtre activé'
      }
      text={
        <div className='flex items-center space-x-1'>
          <BadgeCounter
            isActive={isActive}
            count={count} />
          <span>
            {text}
          </span>
        </div>
      }
      value={isActive ? 'Activé' : undefined}
      onClick={handleOnClick}
      className={className}
      disabled={isLoading} />
  );

};

export default ButtonFilterCountable;
